'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// Storeを生成
const store = new Vuex.Store({
  state: {
    // FKMOの初期処理完了状態
    isInitComplete: false,
    // 選択中の店舗
    select_store: {
      'store_cd': null,
      'store_name': null,
      'opening_time': null,
      'closing_time': null,
      'morning_start_time': null,
      'morning_end_time': null,
      'grand_start_time': null,
      'lastorder_time': null,
      'has_morning_menu': false,
      'address': null,
      'tel': null,
      'latitude': null,
      'longitude': null,
      'services': null,
      'image_url': null,
      outputs: {
        openingTime: null,
        morningTime: null,
        closingTime: null
      }
    },
    // カート
    cart: {
      receive_method: null,
      accounting_coupon: null, // 会計割引クーポン
      item_list: [],
      menu_category_type: null
    },
    // 選択中のカテゴリ
    select_cateogry: {
      category_cd: null,
      category_name: null,
      image_url: null
    },
    // 選択中の商品（カートに追加する前の商品）
    select_item: {
      item: null,
      setmenu: null,
      setmenu_details: [],
      coupon_cd: null,
      quantity: 1,
      isSelectable: false
    },
    // サーバー時間
    server_time: null,
    // 注文明細
    order_detail: {
      orderId: null,
      ticketNumber: null,
      receiveMethod: null,
      store: {
        name: null,
        imageUrl: null
      },
      items: [],
      accountingCoupon: {
        isUse: false,
        couponCd: null,
        title: null,
        discountPrice: 0
      },
      receive_method: 0,
      totalPrice: null,
      taxType: null,
      tableNumber: null,
      discountablePrice: 0 // ポイント割引可能金額
    },
    // 営業中フラグ
    isOpen: false,
    // モーニング/グランド受付中フラグ
    isAcceptingMenu: {
      morning: false,
      grand: false
    },
    // ボタンの非活性化フラグ
    disabledButton: false,
    // アプリからのログイン認証完了フラグ
    authCompletedFromApp: false,
    // 店舗検索で使用する検索項目
    storeSearchParams: {
      latitude: null,
      longitude: null,
      area_cd: null,
      type: 1
    },
    // d払いステータス（未使用：false、使用：true）
    dPayStatus: false,
    // d払い端末（未使用・その他：0、Android：1、iOS：2）
    dPayTerminal: 0,
    // 特権ユーザ用未来日指定
    openAt: null,
    userPolicyAgreed: null,
    userAuthority: 1,
    // クーポン一覧
    couponDetails: [],
    // デバッグモードフラグ
    isDebug: false
  },
  getters: {
    selectStore: state => state.select_store,
    serverTime: state => state.server_time,
    selectCategory: state => state.select_cateogry,
    selectItem: state => state.select_item,
    cart: state => state.cart,
    orderDetail: state => state.order_detail,
    isOpen: state => state.isOpen,
    isAcceptingMenu: state => state.isAcceptingMenu,
    isInitComplete: state => state.isInitComplete,
    disabledButton: state => state.disabledButton,
    authCompletedFromApp: state => state.authCompletedFromApp,
    storeSearchParams: state => state.storeSearchParams,
    isDPayEnabled: state => state.dPayStatus,
    isDPayAndroid: state => state.dPayTerminal === 1,
    isDPayiOS: state => state.dPayTerminal === 2,
    openAt: state => state.openAt,
    userPolicyAgreed: state => state.userPolicyAgreed,
    userAuthority: state => state.userAuthority,
    couponDetails: state => state.couponDetails,
    isDebug: state => state.isDebug
  },
  mutations: {
    setSelectStore (state, selectStore) {
      this.state.select_store = selectStore
    },
    setServerTime (state, datetime) {
      this.state.server_time = datetime
    },
    setReceiveMethod (state, receiveMethod) {
      this.state.cart.receive_method = receiveMethod
    },
    setSelectCategory (state, selectCategory) {
      this.state.select_cateogry = selectCategory
    },
    setSelectItem (state, selectItem) {
      this.state.select_item = selectItem
    },
    setCart (state, cart) {
      this.state.cart = cart
    },
    setOrderDetail (state, orderDetail) {
      this.state.order_detail = orderDetail
    },
    setIsOpen (state, isOpen) {
      this.state.isOpen = isOpen
    },
    setIsAcceptingMenu (state, isAcceptingMenu) {
      this.state.isAcceptingMenu = isAcceptingMenu
    },
    setIsInitComplete (state, initComplete) {
      this.state.isInitComplete = initComplete
    },
    setDisabledButton (state, disabledButton) {
      this.state.disabledButton = disabledButton
    },
    setAuthCompletedFromApp (state, authCompletedFromApp) {
      this.state.authCompletedFromApp = authCompletedFromApp
    },
    setStoreSearchParams (state, storeSearchParams) {
      this.state.storeSearchParams = storeSearchParams
    },
    enableDPay (state) {
      state.dPayStatus = true
    },
    disableDPay (state) {
      state.dPayStatus = false
    },
    setDPayAndroid (state, os) {
      state.dPayTerminal = 1
    },
    setDPayiOS (state, os) {
      state.dPayTerminal = 2
    },
    setOpenAt (state, openAt) {
      this.state.openAt = openAt
    },
    setUserPolicyAgreed (state, agreed) {
      this.state.userPolicyAgreed = agreed
    },
    setUserAuthority (state, authority) {
      this.state.userAuthority = authority
    },
    setCouponDetails (state, couponDetails) {
      this.state.couponDetails = couponDetails
    },
    setIsDebug (state, isDebug) {
      this.state.isDebug = isDebug
    }
  },
  actions: {
    setSelectStore (context, selectStore) {
      context.commit('setSelectStore', selectStore)
    },
    setServerTime (context, datetime) {
      context.commit('setServerTime', datetime)
    },
    setReceiveMethod (context, receiveMethod) {
      context.commit('setReceiveMethod', receiveMethod)
    },
    setSelectCategory (context, selectCateogry) {
      context.commit('setSelectCategory', selectCateogry)
    },
    setSelectItem (context, selectItem) {
      context.commit('setSelectItem', selectItem)
    },
    setCart (context, cart) {
      context.commit('setCart', cart)
    },
    setOrderDetail (context, orderDetail) {
      context.commit('setOrderDetail', orderDetail)
    },
    setIsOpen (context, isOpen) {
      context.commit('setIsOpen', isOpen)
    },
    setIsAcceptingMenu (context, isAcceptingMenu) {
      context.commit('setIsAcceptingMenu', isAcceptingMenu)
    },
    setIsInitComplete (context, initComplete) {
      context.commit('setIsInitComplete', initComplete)
    },
    setDisabledButton (context, disabledButton) {
      context.commit('setDisabledButton', disabledButton)
    },
    setAuthCompletedFromApp (context, authCompletedFromApp) {
      context.commit('setAuthCompletedFromApp', authCompletedFromApp)
    },
    setStoreSearchParams (context, storeSearchParams) {
      context.commit('setStoreSearchParams', storeSearchParams)
    },
    enableDPay (context) {
      context.commit('enableDPay')
    },
    disableDPay (context) {
      context.commit('disableDPay')
    },
    setDPayAndroid (context) {
      context.commit('setDPayAndroid')
    },
    setDPayiOS (context) {
      context.commit('setDPayiOS')
    },
    setOpenAt (context, openAt) {
      context.commit('setOpenAt', openAt)
    },
    setUserPolicyAgreed (context, agreed) {
      context.commit('setUserPolicyAgreed', agreed)
    },
    setUserAuthority (context, authority) {
      context.commit('setUserAuthority', authority)
    },
    setCouponDetails (context, couponDetails) {
      context.commit('setCouponDetails', couponDetails)
    },
    setIsDebug (context, isDebug) {
      context.commit('setIsDebug', isDebug)
    }
  },
  plugins: [createPersistedState({storage: window.sessionStorage})]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js